import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  getAuth, onAuthStateChanged, signInWithEmailAndPassword,
  signOut, signInWithCustomToken,
} from 'firebase/auth';
import { app } from '../utils/firebase';
import { setSSOCookie, getSSOCookie, clearSSOCookie, createGetCustomToken } from '../utils/sso';

const AuthContext = createContext(null);
const auth = getAuth(app);
const getCustomToken = createGetCustomToken(app);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ssoAttempted = false;

    const unsub = onAuthStateChanged(auth, async (u) => {
      if (u) {
        setUser(u);
        setLoading(false);
        try {
          const result = await getCustomToken();
          setSSOCookie(result.data.token);
        } catch (_) {}
      } else if (!ssoAttempted) {
        ssoAttempted = true;
        const ssoToken = getSSOCookie();
        if (ssoToken) {
          try {
            await signInWithCustomToken(auth, ssoToken);
          } catch (_) {
            clearSSOCookie();
            setUser(null);
            setLoading(false);
          }
        } else {
          setUser(null);
          setLoading(false);
        }
      }
    });

    return unsub;
  }, []);

  const login = (email, password) => signInWithEmailAndPassword(auth, email, password);
  const logout = async () => { clearSSOCookie(); await signOut(auth); };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
